module.exports = __webpack_public_path__ + "static/media/logos.9bed6cac.png";